var _excluded = ["alignType", "value", "placeholder", "showNum", "active", "clearable", "disabled", "readonly", "renderContent", "size", "className", "domRef", "onClear"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Fragment, useCallback, useState } from 'react';
import { usePrefixCls } from '@okee-uikit/react-config';
import { classnames } from '@okee-uikit/react-utils';
import { Down, Up, CloseOne } from './../../common/icons';
export function RimlessInput(props) {
  var _props$alignType = props.alignType,
      alignType = _props$alignType === void 0 ? 'left' : _props$alignType,
      value = props.value,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
      showNum = props.showNum,
      active = props.active,
      clearable = props.clearable,
      disabled = props.disabled,
      readonly = props.readonly,
      renderContent = props.renderContent,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      className = props.className,
      domRef = props.domRef,
      onClear = props.onClear,
      extra = _objectWithoutProperties(props, _excluded);

  var cls = classnames(usePrefixCls('rimless-input', {
    size: size,
    active: active,
    align: alignType,
    disabled: disabled,
    readonly: readonly,
    'show-num': showNum != null
  }), className);
  var innerCls = usePrefixCls('rimless-input-inner');
  var showNumCls = usePrefixCls('rimless-input-num');
  var inputIconCls = usePrefixCls('rimless-input-icon');
  var clearCls = classnames(usePrefixCls('rimless-input-close-icon'), inputIconCls);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hover = _useState2[0],
      setHover = _useState2[1];

  var handleMouseEnter = useCallback(function () {
    return setHover(true);
  }, []);
  var handleMouseLeave = useCallback(function () {
    return setHover(false);
  }, []);

  var render = function render() {
    if (renderContent) {
      return renderContent();
    }

    return React.createElement(Fragment, null, value || placeholder, showNum != null && React.createElement("span", {
      className: showNumCls
    }, showNum > 99 ? '99+' : showNum), value && hover && clearable ? React.cloneElement(React.createElement(CloseOne, {
      theme: "filled",
      className: clearCls
    }), {
      onClick: function onClick() {
        onClear === null || onClear === void 0 ? void 0 : onClear();
      },
      key: 'clear'
    }) : active ? React.createElement(Up, {
      className: inputIconCls
    }) : React.createElement(Down, {
      className: inputIconCls
    }));
  };

  return React.createElement("span", {
    className: cls,
    ref: domRef,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, React.createElement("span", _objectSpread({
    className: innerCls
  }, extra), render()));
}